import type { ImageType } from '@vizit/api';
import { createContext } from 'react';
import type { AssetTableState } from './asset-table-provider.state';

interface AssetTableContextValue extends AssetTableState {
  /**
   * The ID of the portfolio to fetch assets for
   *
   * @optional
   * @type {string}
   */
  portfolioId?: string;
  /**
   * Callback to handle product category filter changes
   *
   * @param productCategoryId - The ID of the selected product category
   * @param productCategoryName - The name of the selected product category
   */
  onFilterProductCategory: (productCategoryId: string, productCategoryName: string) => void;
  /**
   * Callback to handle image type filter changes
   *
   * @param imageType - The selected image type (hero or carousel)
   */
  onFilterImageType: (imageType: ImageType | null) => void;
}

/**
 * Context for managing asset table state
 */
const AssetTableContext = createContext<AssetTableContextValue | undefined>(undefined);

export { AssetTableContext };
export type { AssetTableContextValue };
